import { moduleProviderFactory } from 'core/providers';
import { NikoFacilityList } from 'application/niko-facility/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.niko-facility',
                pattern: '/niko-facilities',
                children: [
                    {
                        name: 'master.app.main.niko-facility.list',
                        pattern: '',
                        component: NikoFacilityList,
                        tabTitle: 'MENU.NIKO_FACILITIES',
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'MENU.NIKO_FACILITIES'
                        }
                    }
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.FACILITIES',
                icon: 'facilities',
                order: 4,
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.NIKO_FACILITIES',
                        route: 'master.app.main.niko-facility.list',
                        order: 2,
                        authorization: 'administrationSection.read',
                    }
                ]
            }
        ]
    });
})();

